import React from 'react'
import { camelize } from 'utils'
import { DealSheetStatus } from 'components/icons'

export default function StatusTag(props) {
  const { status } = props
  const iconName = camelize(status)
  const StatusIcon = DealSheetStatus[iconName] || DealSheetStatus.unknown

  return (
    <StatusIcon />
  )
}